import { ThemeProvider } from "@material-ui/styles";
import Layout from "./components/layout/Layout";
import * as constants from "./constants";
import { CssBaseline } from "@material-ui/core";
import Home from "./components/Home";
import "./App.css";

function App() {
  return (
    <ThemeProvider theme={constants.THEME}>
      <CssBaseline />
      <Layout>
        <Home />
      </Layout>
    </ThemeProvider>
  );
}

export default App;
